module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('bar-top'), _vm._v(" "), _c('div', {
    staticClass: "filter-bar"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('h2', {
    staticClass: "col-md-2"
  }, [_vm._v(_vm._s(_vm.overviewTitle))]), _vm._v(" "), _c('div', {
    staticClass: " col-md-2"
  }, [(_vm.paginationData) ? _c('div', {
    staticClass: "paginationInfo"
  }, [_vm._v("\n          " + _vm._s(_vm.paginationData.from) + "-" + _vm._s(_vm.paginationData.to) + " of " + _vm._s(_vm.paginationData.total) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.paginationData) ? _c('div', {}, [_c('button', {
    staticClass: "btn btn-default btn-sm ",
    attrs: {
      "disabled": !_vm.paginationData || _vm.paginationData.current_page === 1
    },
    on: {
      "click": function($event) {
        _vm.table.gotoPreviousPage()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-step-backward",
    attrs: {
      "i": ""
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default btn-sm",
    attrs: {
      "disabled": !_vm.paginationData || _vm.paginationData.current_page === _vm.paginationData.last_page
    },
    on: {
      "click": function($event) {
        _vm.table.gotoNextPage()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-step-forward",
    attrs: {
      "i": ""
    }
  })])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-inline col-md-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchRec[_vm.tableCfg.quickFilterField]),
      expression: "searchRec[tableCfg.quickFilterField]"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": _vm.tableCfg.quickFilterName
    },
    domProps: {
      "value": (_vm.searchRec[_vm.tableCfg.quickFilterField])
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.searchRec, _vm.tableCfg.quickFilterField, $event.target.value)
      }, _vm.quickFilterChanged],
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        $event.preventDefault();
        _vm.doQuickFilter($event)
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default btn-sm",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.resetFilter($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  })]), _vm._v(" "), (_vm.tableCfg.advancedSearch) ? _c('b-form-checkbox', {
    model: {
      value: (_vm.advancedFilter),
      callback: function($$v) {
        _vm.advancedFilter = $$v
      },
      expression: "advancedFilter"
    }
  }, [_vm._v("Advanced")]) : _vm._e()], 1), _vm._v(" "), _c('div', [(!_vm.disableNew) ? _c('button', {
    staticClass: "btn btn-default btn-sm",
    on: {
      "click": _vm.gotoNewDetail
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })]) : _vm._e(), _vm._v(" "), _vm._t("ExtraOptions")], 2)]), _vm._v(" "), (_vm.tableCfg.advancedSearch && _vm.advancedFilter) ? _c('b-card', {
    staticClass: "mb-2"
  }, [(_vm.advancedFilter) ? _vm._t("AdvancedFilter", [_vm._v("\n        Here is the advanced filter\n      ")]) : _vm._e()], 2) : _vm._e()], 1), _vm._v(" "), (_vm.batchMode) ? _c('b-progress', {
    attrs: {
      "value": _vm.batchCounter,
      "max": _vm.batchMax,
      "show-progress": true,
      "show-value": true
    }
  }) : _vm._e(), _vm._v(" "), _c('alert-handler', {
    ref: "alert"
  }), _vm._v(" "), _c('vuetable', {
    ref: "vuetable",
    attrs: {
      "apiUrl": _vm.apiUrl,
      "fields": _vm.fields,
      "sortOrder": _vm.tableCfg.sortOrder,
      "perPage": 50,
      "initialPage": _vm.findInitialPage(),
      "multiSort": true,
      "appendParams": _vm.appendParams,
      "css": _vm.css.table
    },
    on: {
      "vuetable:pagination-data": _vm.onPaginationData,
      "vuetable:load-error": _vm.onLoadError
    },
    scopedSlots: _vm._u([{
      key: "actions",
      fn: function(props) {
        return [_c('div', {
          staticClass: "custom-actions"
        }, [_c('button', {
          staticClass: "btn btn-default btn-sm",
          attrs: {
            "disabled": !_vm.privUser
          },
          on: {
            "click": function($event) {
              _vm.$router.push({
                name: _vm.detailRouterUrl,
                params: {
                  id: props.rowData.id
                },
                query: {
                  mode: 'edit'
                }
              })
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-pencil"
        })]), _vm._v(" "), _vm._t("ExtraRowActions", null, {
          rowData: props.rowData
        })], 2)]
      }
    }])
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-19436cbe"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/OverviewLayout.vue
// module id = 693
// module chunks = 1